import type { BoxProps } from '@mui/material/Box';

import { forwardRef } from 'react';

import Box from '@mui/material/Box';
import NoSsr from '@mui/material/NoSsr';

import { RouterLink } from 'src/routes/components';

import { CONFIG } from 'src/config-global';

import { logoClasses } from './classes';

// ----------------------------------------------------------------------

export type LogoProps = BoxProps & {
  href?: string;
  disableLink?: boolean;
  logoType?: 'row' | 'column';
};

const logoRow = `${CONFIG.site.basePath}/logo/logo-row.png`;
const logoColumn = `${CONFIG.site.basePath}/logo/logo-column.png`;

export const Logo = forwardRef<HTMLDivElement, LogoProps>(
  (
    {
      width = 40,
      height = 40,
      disableLink = false,
      className,
      href = '/dashboard',
      sx,
      logoType = 'row',
      ...other
    },
    ref
  ) => {
    const logo = (
      <Box
        alt="logo"
        component="img"
        src={logoType === 'row' ? logoRow : logoColumn}
        width={width}
        height={height}
        sx={{
          objectFit: 'contain',
        }}
      />
    );

    return (
      <NoSsr
        fallback={
          <Box
            width={width}
            height={height}
            className={logoClasses.root.concat(className ? ` ${className}` : '')}
            sx={{ flexShrink: 0, display: 'inline-flex', verticalAlign: 'middle', ...sx }}
          />
        }
      >
        <Box
          ref={ref}
          component={RouterLink}
          href={href}
          width={width}
          height={height}
          className={logoClasses.root.concat(className ? ` ${className}` : '')}
          aria-label="logo"
          sx={{
            flexShrink: 0,
            display: 'inline-flex',
            verticalAlign: 'middle',
            ...(disableLink && { pointerEvents: 'none' }),
            ...sx,
          }}
          {...other}
        >
          {logo}
        </Box>
      </NoSsr>
    );
  }
);
